import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-historique-savoir-etre',
  templateUrl: './historique-savoir-etre.component.html',
  styleUrls: ['./historique-savoir-etre.component.css']
})
export class HistoriqueSavoirEtreComponent implements OnInit {
  @Input() COMMUNICATION: any
  @Input() MANAGEMENT: any
  @Input() VALEURS: any
  @Input() RESULTATS: any
  public note_management: any = 0;
  public resultat_management: any = 0;
  public nbre_rubrique_evaluee_management: any = 0;
  public note_communication: any = 0;
  public resultat_communication: any = 0;
  public nbre_rubrique_evaluee_communication: any = 0;
  public nbre_rubrique_evaluee_global: any = 0;
  public note_valeurs: any = 0;
  public resultat_valeurs: any = 0;
  public nbre_rubrique_evaluee_valeurs: any = 0;
  public appreciation_management: any = 'Non-Evalué';
  public appreciation_communication: any = 'Non-Evalué';
  public appreciation_valeurs: any = 'Non-Evalué';
  public note_hors_encadrement: any;
  public note_cadres_encadrement: any;
  public appreciation_global_hors_encadrement: any;
  public appreciation_global_encadrement: any;
  public note_global_encadrement: any;
  public resultat_global_encadrement: any;
  public note_global_hors_encadrement: any;
  public resultat_global_hors_encadrement: any;
  public arrayNotationsManagement: any = [];
  public arrayNotationsCommunication: any = [];
  public arrayNotationsValeurs: any = [];
  public listManagement: any = [];
  public listCommunication: any = [];
  public listValeurs: any = [];
  public typeVisualisation: any;
  public typeFiche: any;
  public entretien_id: any;
  public vueActive: any;
  public statut: any;
  public agent_id: any;
  public typeSauvegarde: any;
  public resultat_global: any;
  public appreciation_global: any;

  constructor() { }

  public getListeManagement(): void {
    this.listManagement = this.MANAGEMENT?.sous_rubriques;

    this.note_management = this.MANAGEMENT?.data?.resultat?.moyenne;
    this.resultat_management = this.RESULTATS?.management?.resultat_management;
    this.appreciation_management = this.RESULTATS?.management?.appreciation_management;
    this.nbre_rubrique_evaluee_management = this.listManagement?.length;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    let notationsRubriqueQuatre = [];
    let notationsRubriqueCinq = [];
    let notationsRubriqueSix = [];
    let notationsRubriqueSept = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     * @param notationsRubriqueQuatre correspond a la quatrième rubrique de la section maitrise du poste
     * @param notationsRubriqueCinq correspond a la cinquième rubrique de la section maitrise du poste
     * @param notationsRubriqueSix correspond a la sixième rubrique de la section maitrise du poste
     * @param notationsRubriqueSept correspond a la septième rubrique de la section maitrise du poste
     */
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueUn = this.listManagement[0].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueDeux = this.listManagement[1].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueTrois = this.listManagement[2].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueQuatre = this.listManagement[3].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueQuatre.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueCinq = this.listManagement[4].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueCinq.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueSix = this.listManagement[5].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueSix.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listManagement?.length; index++) {
      notationsRubriqueSept = this.listManagement[6].notations.filter(element => element.ischecked === true);
    }
    notationsRubriqueSept.forEach(element => {
      this.arrayNotationsManagement.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
  }

  public getListeCommunication(): void {

    this.listCommunication = this.COMMUNICATION?.sous_rubriques;

    this.note_communication = this.COMMUNICATION?.data?.resultat?.moyenne;
    this.resultat_communication = this.RESULTATS?.communication?.resultat_communication;
    this.appreciation_communication = this.RESULTATS?.communication?.appreciation_communication;
    this.nbre_rubrique_evaluee_communication = this.listCommunication?.length;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     */

    for (let index = 0; index <= this.listCommunication?.length; index++) {
      notationsRubriqueUn = this.listCommunication[0]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsCommunication.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });

    for (let index = 0; index <= this.listCommunication?.length; index++) {
      notationsRubriqueDeux = this.listCommunication[1]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsCommunication.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });

    for (let index = 0; index <= this.listCommunication?.length; index++) {
      notationsRubriqueTrois = this.listCommunication[2]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsCommunication.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });

  }

  public getListeValeurs(): void {
    this.listValeurs = this.VALEURS?.sous_rubriques;

    this.note_valeurs = this.VALEURS?.data?.resultat?.moyenne;
    this.resultat_valeurs = this.RESULTATS.valeur?.resultat_valeur;
    this.appreciation_valeurs = this.RESULTATS.valeur?.appreciation_valeur;
    this.nbre_rubrique_evaluee_valeurs = this.listValeurs?.length;

    let notationsRubriqueUn = [];
    let notationsRubriqueDeux = [];
    let notationsRubriqueTrois = [];
    let notationsRubriqueQuatre = [];
    let notationsRubriqueCinq = [];
    /**
     * @param notationsRubriqueUn correspond a la première rubrique de la section maitrise du poste
     * @param notationsRubriqueDeux correspond a la deuxième rubrique de la section maitrise du poste
     * @param notationsRubriqueTrois correspond a la troisième rubrique de la section maitrise du poste
     * @param notationsRubriqueQuatre correspond a la quatrième rubrique de la section maitrise du poste
     * @param notationsRubriqueCinq correspond a la cinquième rubrique de la section maitrise du poste
     */
    for (let index = 0; index <= this.listValeurs?.length; index++) {
      notationsRubriqueUn = this.listValeurs[0]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueUn.forEach(element => {
      this.arrayNotationsValeurs.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listValeurs?.length; index++) {
      notationsRubriqueDeux = this.listValeurs[1]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueDeux.forEach(element => {
      this.arrayNotationsValeurs.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listValeurs?.length; index++) {
      notationsRubriqueTrois = this.listValeurs[2]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueTrois.forEach(element => {
      this.arrayNotationsValeurs.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listValeurs?.length; index++) {
      notationsRubriqueQuatre = this.listValeurs[3]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueQuatre.forEach(element => {
      this.arrayNotationsValeurs.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });
    for (let index = 0; index <= this.listValeurs?.length; index++) {
      notationsRubriqueCinq = this.listValeurs[4]?.notations?.filter(element => element.ischecked === true);
    }
    notationsRubriqueCinq.forEach(element => {
      this.arrayNotationsValeurs.push(
        {
          'id': element.id,
          'rubrique_id': element.rubrique_id
        }
      );
    });

  }

  public checkSums(data) {
    let totalSums
    let barems = [] as any
    let newArray = []
    for (const value of data) {
      for (const row of value.notations) {
        if (row.ischecked) {
          newArray.push(row);
        }
      }
    }

    newArray.forEach((element) => {
      barems.push(element.barem)
    });


    totalSums = barems.reduce(
      (acc, item) => acc + parseInt(item.valeur),
      0
    );

    return totalSums
  }

  public ngOnInit(): void {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];

    this.getListeManagement();
    this.getListeCommunication();
    this.getListeValeurs();

    this.resultat_global = this.RESULTATS?.synthese_savoir_etre_tt?.note
    this.nbre_rubrique_evaluee_global = this.RESULTATS?.synthese_savoir_etre_tt?.nbre
    this.appreciation_global = this.RESULTATS?.savoir_etre?.appreciation_savoir_etre
  }

  public containsObjectArrayManagement(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsManagement?.length; i++) {
      if (this.arrayNotationsManagement[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  public containsObjectArrayCommunication(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsCommunication?.length; i++) {
      if (this.arrayNotationsCommunication[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  public containsObjectArrayValeurs(id_rubrique) {
    let i;
    for (i = 0; i < this.arrayNotationsValeurs?.length; i++) {
      if (this.arrayNotationsValeurs[i].rubrique_id === id_rubrique) {
        return true;
      }
    }
    return false;
  }

  public isCheckedManagement(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayManagement(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsManagement.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
    } else {
      const new_array = this.arrayNotationsManagement.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsManagement = new_array;
      this.arrayNotationsManagement.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsManagement;
  }

  public isCheckedCommunication(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayCommunication(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsCommunication.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
    } else {
      const new_array = this.arrayNotationsCommunication.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsCommunication = new_array;
      this.arrayNotationsCommunication.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsCommunication;
  }

  public isCheckedValeurs(rubrique_id, notations_id) {
    const is_exist = this.containsObjectArrayValeurs(rubrique_id);
    if (!is_exist) {
      this.arrayNotationsValeurs.push({
        'rubrique_id': rubrique_id,
        'id': notations_id,
      });
    } else {
      const new_array = this.arrayNotationsValeurs.filter(
        (element) => element.rubrique_id !== rubrique_id
      );
      this.arrayNotationsValeurs = new_array;
      this.arrayNotationsValeurs.push({
        'id': notations_id,
        'rubrique_id': rubrique_id
      });
    }
    return this.arrayNotationsValeurs;
  }


}
